(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useRef = _React.useRef;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const getPixHandler = svs.components.sport.pixHandler.getPixHandler;
const useFocusTrap = svs.components.lbUtils.useFocusTrap;
const _svs$components$sport = svs.components.sport.quickplayModal,
  Modal = _svs$components$sport.Modal,
  QuickplayModalHeader = _svs$components$sport.QuickplayModalHeader,
  QuickplayModalMain = _svs$components$sport.QuickplayModalMain,
  QuickplayModalFooter = _svs$components$sport.QuickplayModalFooter;
const QuickplayModal = _ref => {
  let branding = _ref.branding,
    productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    systemCost = _ref.systemCost,
    rowPrice = _ref.rowPrice,
    wallet = _ref.wallet,
    onModalClose = _ref.onModalClose,
    hasPortal = _ref.hasPortal,
    isPixMix = _ref.isPixMix,
    systemType = _ref.systemType,
    productSizes = _ref.productSizes,
    competitionBranding = _ref.competitionBranding,
    redirectToOnPaymentComplete = _ref.redirectToOnPaymentComplete,
    initiator = _ref.initiator;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    modalRef = _useState2[0],
    setModalRef = _useState2[1];
  const _useFocusTrap = useFocusTrap({
      refocus: true
    }),
    releaseFocus = _useFocusTrap.releaseFocus,
    trapFocus = _useFocusTrap.trapFocus;
  const history = useHistory();
  const pixHandler = getPixHandler({
    isPixMix
  });
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isStillOpen = _useState4[0],
    setIsStillOpen = _useState4[1];
  useEffect(() => {
    if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
      trapFocus(modalRef.current);
    }
  }, [modalRef, trapFocus]);
  const handleClose = useCallback(() => {
    pixHandler.unsetKeepOpenItem();
    svs.ui.loader.hide();
    setIsStillOpen(false);
    releaseFocus(initiator, () => {
      setModalRef(null);
    });
    if (onModalClose) {
      onModalClose();
    }
  }, [onModalClose, pixHandler, releaseFocus, initiator]);
  const handleRedirect = useCallback(() => {
    if (redirectToOnPaymentComplete) {
      history.push(redirectToOnPaymentComplete);
    }
  }, [history, redirectToOnPaymentComplete]);
  const _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    drawData = _useState6[0],
    setDrawData = _useState6[1];
  const _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    pixData = _useState8[0],
    setPixData = _useState8[1];
  const _useState9 = useState(systemCost),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedSystemCost = _useState0[0],
    setSelectedSystemCost = _useState0[1];
  const pixInfoRef = useRef();
  const setNewPixMessage = useCallback(() => {
    if (!pixInfoRef.current) {
      return;
    }

    if (pixInfoRef.current.innerHTML.indexOf('.') !== -1) {
      pixInfoRef.current.innerHTML = 'Ny PIX genererad';
    } else {
      pixInfoRef.current.innerHTML = 'Ny PIX genererad.';
    }
  }, []);
  const refreshPix = useCallback(async (updatedSystemCost, shouldGenerateNewPix) => {
    if (selectedSystemCost !== updatedSystemCost) {
      setSelectedSystemCost(updatedSystemCost);
    } else {
      const _await$svs$components = await svs.components.sport.quickplayModal.services.fetchDrawAndPix({
          productId,
          drawNumber,
          systemType,
          systemCost: selectedSystemCost,
          rowPrice,
          branding,
          productSizes,
          isPixMix,
          shouldGenerateNewPix
        }),
        drawResponse = _await$svs$components.drawResponse,
        pixResponse = _await$svs$components.pixResponse;
      setDrawData(_objectSpread({}, drawResponse));
      setPixData(_objectSpread({}, pixResponse));
      if (shouldGenerateNewPix) {
        setNewPixMessage();
      }
    }
  }, [productId, drawNumber, systemType, selectedSystemCost, rowPrice, branding, productSizes, isPixMix, setNewPixMessage]);
  useEffect(() => {
    refreshPix(selectedSystemCost);
  }, [selectedSystemCost, refreshPix]);
  if (!drawData || !pixData) {
    return null;
  }
  if (!isStillOpen) {
    return null;
  }
  return React.createElement(Modal, {
    ariaLabel: "PIX widget",
    handleCloseModal: handleClose,
    hasPortal: hasPortal,
    isClosingOnBackgroundClick: true,
    setModalRef: setModalRef
  }, React.createElement("div", {
    className: "quickplay-modal quickplay-modal-branding-".concat(branding, " fc-white")
  }, React.createElement(QuickplayModalHeader, {
    handleClose: handleClose,
    productId: productId
  }), React.createElement(QuickplayModalMain, {
    branding: branding,
    drawData: drawData,
    isPixMix: isPixMix,
    onRefreshPix: _ref2 => {
      let updatedSystemCost = _ref2.updatedSystemCost,
        shouldGenerateNewPix = _ref2.shouldGenerateNewPix;
      refreshPix(updatedSystemCost, shouldGenerateNewPix);
    },
    productSizes: productSizes
  }), React.createElement(QuickplayModalFooter, {
    competitionBranding: competitionBranding,
    drawData: drawData,
    handleClose: handleClose,
    handleRedirect: handleRedirect,
    hasSaveButton: isPixMix,
    isPixMix: isPixMix,
    wallet: wallet
  }), React.createElement("div", {
    "aria-live": "polite",
    className: "sr-only",
    ref: pixInfoRef,
    role: "status"
  })));
};
QuickplayModal.defaultProps = {
  isPixMix: false
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModal', QuickplayModal);

 })(window);